export const handleShowFooter = (payload) => ({type: "SHOW_FOOTER", payload})